import { createSlice } from '@reduxjs/toolkit';

const autoplaySessionActiveSlice = createSlice({
  name: 'autoplaySessionActive',
  initialState: false,
  reducers: {
    setAutoplaySessionActive: (state, action) => {
      state = action.payload;
      return state;
    }
  },
});

export const { setAutoplaySessionActive } = autoplaySessionActiveSlice.actions;
export default autoplaySessionActiveSlice.reducer;